// constants.js
export const NORMAL_VICTORY_BASE_POINTS = 50; // points maximum pour une victoire normale
//export const NORMAL_VICTORY_GUESS_FACTOR = 5; // chaque essai en moins fait gagner 5 points en plus

export const HARDCORE_VICTORY_BONUS = 100; // bonus en cas de victoire hardcore

export const SONG_AVAILABILITY_INITIAL = 5; // en pourcentage (10% des chansons par style au départ)
export const SONG_AVAILABILITY_INCREMENT = 5; // on ajoute 10% par palier
export const SONG_AVAILABILITY_THRESHOLD = 200; // seuil de trophées pour débloquer 10% supplémentaires

export const N_CLUES = 5;

export const N_CLUE_BUY = 5; // nombre d'indices achetables pour 30 trophées

// Coût pour acheter des indices : 5 indices pour 30 trophées
export const CLUE_COST_COUNT = 5;
export const CLUE_COST_TROPHIES = 30;

// Nombre de chansons requises pour débloquer un palier (ex : 2 chansons)
export const SONGS_REQUIRED = 2;

export const styleEmojis = {
    "Pop": "💃",
    "Rock": "🎸",
    "Rap": "🎧",
    "French Classics": "📜",
    "French Youtube": "🎥",
    "Disney Songs": "🏰",
    "Metal": "🤘",
    "Reggae": "🇯🇲",
    "Jazz": "🎷",
    "Electro": "🎹",
    "Variété": "🎶",
    "Disco": "🕺",
    "Blues": "🎺",
    "Funk": "🎺",
    "Country": "🤠",
    "Soul": "🎙️",
    "Reggaeton": "🇵🇷",
    "R&B": "🎤",
    "Techno": "🎛️",
    "Punk": "🤘",
    "Indie": "🎸",
    "Folk": "🎻",
    "Gospel": "⛪",
    "Ambiance": "🎉",
    "Latino": "🇪🇸",
    "K-Pop": "🇰🇷",
    "World": "🌍",
    "Autre": "🎵"
};